//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import Rectangle from './Rectangle.vue'

export default {
  components: {
    Rectangle
  },
  props: {
    routeSource: {
      type: Object,
      default: null
    }
  },
  computed: {
    turnRegistered: function () {
      return this.getChildrenBlockByType('turnRegistered')
    },
    turnRegisteredVk: function () {
      return this.getChildrenBlockByType('turnRegisteredVk')
    },
    turnRegisteredNk: function () {
      return this.getChildrenBlockByType('turnRegisteredNk')
    },
    turnRegisteredPk: function () {
      return this.getChildrenBlockByType('turnRegisteredPk')
    },
    turnExecuted: function () {
      return this.getChildrenBlockByType('turnExecuted')
    },
    turnExecutedVk: function () {
      return this.getChildrenBlockByType('turnExecutedVk')
    },
    turnExecutedNk: function () {
      return this.getChildrenBlockByType('turnExecutedNk')
    },
    turnExecutedPk: function () {
      return this.getChildrenBlockByType('turnExecutedPk')
    },
    turnInWork: function () {
      return this.getChildrenBlockByType('turnInWork')
    },
    turnInWorkVk: function () {
      return this.getChildrenBlockByType('turnInWorkVk')
    },
    turnInWorkNk: function () {
      return this.getChildrenBlockByType('turnInWorkNk')
    },
    turnInWorkPk: function () {
      return this.getChildrenBlockByType('turnInWorkPk')
    }
  },
  methods: {
    getChildrenBlockByType: function (type) {
      const routeSourceChildrens = this.routeSource && this.routeSource.compound && this.routeSource.compound.flatMap(compound => compound.children)
      return routeSourceChildrens && routeSourceChildrens.find(children => children.type === type)
    }
  }
}
